import * as angular from 'angular';
import {LocationRequestsService} from "./location-requests.service";
import {LocationHolderType} from "../types/locationHolder.type";
import {IQService} from "angular";
import {LogisticsVehiclesAlertsService} from "../../logistics-vehicle/services/logistics-vehicles-alerts.service";
import {BringozLoaderService} from "./bringoz-loader.service";

export class LocationService {

  constructor(private $q: IQService, private bringozLoaderService: BringozLoaderService,
              private locationRequestsService: LocationRequestsService,
              private logisticsVehiclesAlertsService: LogisticsVehiclesAlertsService, private $log) {
  }

  // Payload
  // {
  //   "holderId": "1869df515ac4c3515b811aa374a",
  //   "holder": "LogisticsVehicle"
  // }
  getLocations(payload: {holderId: string, holder: LocationHolderType}[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.locationRequestsService.getLocations(payload)
      .then((location) => {
        deferred.resolve(location);
      })
      .catch((error) => {
        this.$log.error(error);
        // this.logisticsVehiclesAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getAgentLocation(id: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.locationRequestsService.getAgentLocation(id)
      .then((location) => {
        deferred.resolve(location);
      })
      .catch((error) => {
        this.$log.error(error);
        // this.logisticsVehiclesAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getLogisticsVehicleLocation(id: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.locationRequestsService.getLogisticsVehicleLocation(id)
      .then((location) => {
        deferred.resolve(location);
      })
      .catch((error) => {
        this.$log.error(error);
        // this.logisticsVehiclesAlertsService.createError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }


}

angular
  .module('bringoz.admin.commons')
  .service('locationService', LocationService);

